<!-- <p>csv-table works!</p> -->
<div class="csv-table-container">
  <!-- <mat-table [dataSource]="dataSource">
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
          <mat-header-cell *matHeaderCellDef class="custom-header-cell">
            {{ column | titlecase }}
          </mat-header-cell>
          <mat-cell *matCellDef="let item" class="custom-cell">
            <input [(ngModel)]="item[column]" class="editable-input" />
          </mat-cell>
        </ng-container>
      
        <mat-header-row *matHeaderRowDef="displayedColumns" class="custom-header-row"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" class="custom-row"></mat-row>
      </mat-table> -->

  <mat-table [dataSource]="dataSource">
    <ng-container
      *ngFor="let column of displayedColumns"
      [matColumnDef]="column"
    >
      <mat-header-cell *matHeaderCellDef class="custom-header-cell">
        {{ column | titlecase }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let item"
        class="custom-cell"
        (click)="editCell(item, column)"
      >
        <ng-container *ngIf="!isEditing(item, column); else editTemplate">
          {{ item[column] }}
        </ng-container>
        <ng-template #editTemplate>
          <div class="editable-cell">
            <input
              [ngModel]="item[column]"
              (ngModelChange)="editingCellValue($event)"
              class="editable-input"
              (keyup.enter)="onEnterKey($event, item, column)"
              (keyup.escape)="cancelEdit()"
            />
          </div>
        </ng-template>
      </mat-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="displayedColumns"
      class="custom-header-row"
    ></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="custom-row"
    ></mat-row>
  </mat-table>
</div>
<div class="mat-tile-button">
  <button (click)="sendGuestData()" mat-raised-button type="button">
    Send Invitations
  </button>
</div>
